<template>
  <v-app>
    <v-app-bar app color="primary" density="comfortable">
      <v-app-bar-title class="font-weight-bold d-none d-sm-flex">山域搜救情報分析系統</v-app-bar-title>
      <v-app-bar-title class="font-weight-bold d-flex d-sm-none">山搜系統</v-app-bar-title>
      <v-spacer />
      
      <!-- 案件資訊顯示 -->
      <div v-if="caseStore.id" class="d-flex align-center mr-4">
        <v-chip color="white" variant="tonal" size="small" class="mr-2">
          案件: {{ caseStore.id }}
        </v-chip>
      </div>
      
      <!-- 重置按鈕 -->
      <v-btn
        @click="resetAllData"
        variant="outlined"
        color="white"
        size="small"
        prepend-icon="mdi-refresh"
        class="text-none"
      >
        全部重置
      </v-btn>
    </v-app-bar>
    <v-main class="bg-grey-lighten-4">
      <v-container class="py-6">
        <router-view />
      </v-container>
    </v-main>
    
    <!-- 通知訊息 -->
    <v-snackbar v-model="notifier.show" :timeout="notifier.timeout" :color="notifier.color" location="top right">
      {{ notifier.text }}
    </v-snackbar>
    
    <!-- 全域 Loading Overlay -->
    <LoadingOverlay @cancel="handleLoadingCancel" />
  </v-app>
</template>

<script>
import { useRouter } from 'vue-router'
import { notifier } from '@/store/notifier'
import { caseStore, resetCaseStore } from '@/store/caseStore'
import LoadingOverlay from '@/components/LoadingOverlay.vue'

export default {
  name: 'App',
  components: {
    LoadingOverlay
  },
  setup() {
    const router = useRouter()
    
    function resetAllData() {
      resetCaseStore()
      notifier.show = true
      notifier.text = '資料已重置，返回首頁'
      notifier.color = 'success'
      notifier.timeout = 3000
      
      // 跳轉回首頁
      router.push('/create-case')
    }
    
    function handleLoadingCancel() {
      // 處理用戶取消 Loading 的情況
      console.log('用戶取消了 Loading')
      notifier.show = true
      notifier.text = '分析已取消'
      notifier.color = 'warning'
      notifier.timeout = 3000
    }
    
    return { 
      notifier, 
      caseStore,
      resetAllData,
      handleLoadingCancel
    }
  }
}
</script>

<style>
html,
body,
#app {
  height: 100%;
}
</style>
